interface QlashIconProps {
  size?: number;
  className?: string;
}

/**
 * QLASH "Q" wordmark, ported 1:1 from mobile-app/src/lib/icons/icons.tsx.
 * Uses `currentColor` so the parent's text color drives the fill.
 */
export function QlashIcon({ size = 24, className }: QlashIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        d="M28.2175 24.9359C27.9412 24.8448 26.0988 24.2077 26.0988 24.2077C22.2297 22.5238 20.8479 21.4315 19.0515 19.7021C19.1897 22.4328 21.0321 23.5705 21.0321 23.5705H18.0843C14.1692 23.5705 14.2152 19.7021 15.4589 17.8362C17.3013 15.242 20.157 15.7427 20.2031 15.7427C18.5449 15.7427 17.2552 16.5163 16.3801 17.4721C16.3801 17.4721 16.9788 17.1535 18.4067 17.0625C19.4661 16.9715 21.9994 17.017 22.9667 17.108C23.3351 17.1535 24.3024 17.3355 24.9472 17.7906C27.5727 19.6111 27.1121 22.5693 27.1121 22.5693C27.02 20.2027 25.8685 19.247 25.8224 19.247C26.4212 21.8866 24.8091 22.7968 24.8091 22.7968C24.8091 22.7968 27.3884 24.1622 28.5399 23.434C31.626 21.2495 29.8296 16.1523 29.7836 16.0157C29.9678 16.9715 29.7375 18.2002 29.6914 18.2002C28.2175 13.2396 24.2563 13.103 24.2563 13.103C28.2175 15.0145 27.5727 18.4278 27.5727 18.4733C27.2963 13.6036 22.5982 13.2851 22.5982 13.2851C23.3351 13.6492 23.5654 13.7857 23.5654 13.7857C12.6492 12.1018 12.8795 18.2458 12.9255 18.7464C12.511 16.1978 14.2613 14.6049 14.2613 14.5594C9.47103 16.5619 10.8068 21.6591 10.8068 21.6591C10.1159 21.1129 9.70133 20.5213 9.65527 20.5213C11.728 25.1634 15.551 24.9359 15.5049 24.9359C13.1558 25.2089 11.5898 23.8436 11.5898 23.7981C13.8007 27.1204 18.5449 26.8928 18.5449 26.8928H30.2442C30.2442 26.8928 29.323 25.664 29.0927 25.3455C28.8624 25.0269 28.4939 24.9814 28.2175 24.9359ZM23.7036 24.2987L25.9606 25.0269C25.9606 25.0269 24.3024 25.4365 23.7036 24.2987ZM27.5727 25.3455C28.3557 25.391 28.7702 25.482 28.7702 25.482L29.0005 25.8006C29.0005 25.8006 28.0793 25.482 27.5727 25.3455Z"
        fill="currentColor"
      />
    </svg>
  );
}
